<template>
  <div class="show-photo" v-show="isOpen" @click="close">
    <div :class="getClass">
      <img :src="imgData[src]" alt="暂无图片信息" @click="close" />
    </div>
  </div>
</template>

<script>
import {
  move01,
  move02,
  move03,
  move04,
  move05,
  move06,
  move07,
  move08,
  move09,
  move10,
  move11,
  move12,
  move13,
  move14,
  move15,
  move16,
  move17,
  move18,
  move19,
  move20,
  move21,
  move22,
  move23,
  move24,
  move25,
  move26,
  move27,
  move28
} from "@/utils/utils";
export default {
  props: {
    isOpen: {
      type: Boolean,
      default: false
    },
    isH5: {
      type: Boolean,
      default: false
    },
    src: {
      type: Number,
      default: 0
    }
  },
  computed: {
    getClass() {
      return this.isH5 ? "h5div" : "webdiv";
    }
  },
  data() {
    return {
      imgData: [
        move01,
        move02,
        move03,
        move04,
        move05,
        move06,
        move07,
        move08,
        move09,
        move10,
        move11,
        move12,
        move13,
        move14,
        move15,
        move16,
        move17,
        move18,
        move19,
        move20,
        move21,
        move22,
        move23,
        move24,
        move25,
        move26,
        move27,
        move28
      ]
    };
  },
  watch: {
    isOpen(val) {
      if (val) {
        document.documentElement.style.overflowY = "hidden";
      } else {
        document.documentElement.style.overflowY = "auto";
      }
    }
  },
  methods: {
    close() {
      this.$emit("closePage");
    }
  }
};
</script>

<style lang="less">
.show-photo {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.8);
  overflow: auto !important;
  z-index: 999;
  > .h5div {
    width: 100vw;
    height: 100vh;
    display: flex;
    justify-content: center;
    align-items: center;
    > img {
      width: 1rem;
      height: 1.5rem;
      -moz-user-select: none; /*火狐*/
      -webkit-user-select: none; /*webkit浏览器*/
      -ms-user-select: none; /*IE10*/
      -khtml-user-select: none; /*早期浏览器*/
      user-select: none;
    }
  }

  > .webdiv {
    width: 100vw;
    height: 100vh;
    display: flex;
    justify-content: center;
    align-items: center;
    > img {
      -moz-user-select: none; /*火狐*/
      -webkit-user-select: none; /*webkit浏览器*/
      -ms-user-select: none; /*IE10*/
      -khtml-user-select: none; /*早期浏览器*/
      user-select: none;
      // height: 70%;
      width: 620px;
      height: 900px;
    }
  }
}
</style>
